import { z } from 'zod/v4';

import { foldSynonyms, isString, normalizeFlatArgs } from '../widget-schemas/fold-helpers';

export const BLOCK_ID_SYNONYM_KEYS = ['id', 'block_id'] as const;

const removeBlockObjectSchema = z.object({
    blockId: z.string().describe('Id of the block to remove.'),
});

export const removeBlockArgsSchema = z.preprocess(
    (raw) => normalizeFlatArgs(raw, (args) => foldSynonyms(args, args, 'blockId', BLOCK_ID_SYNONYM_KEYS, isString)),
    removeBlockObjectSchema
);
